export const textStyles = {
  large: {
    fontSize: { base: "18px", lg: "20px" },
    fontWeight: 500,
    lineHeight: 1.4,
  },
  medium: {
    fontSize: "clamp(16px, 5vw, 18px)",
    lineHeight: 1.5,
  },
  normal: {
    fontSize: "clamp(14px, 5vw, 15px)",
    lineHeight: 1.5,
  },
  small: {
    fontSize: "clamp(12px, 5vw, 13px)",
    lineHeight: 1.4,
  },
  tiny: {
    fontSize: "clamp(10px, 5vw, 11px)",
    lineHeight: 1.4,
  },

  header2: {
    fontSize: "clamp(18px, 5vw, 22px)",
    fontWeight: 600,
    lineHeight: 1.4,
  },
  header1b: {
    fontSize: "clamp(16px, 5vw, 34px)",
    fontWeight: 600,
    lineHeight: 1.4,
  },
  header1a: {
    fontSize: "clamp(20px, 9vw, 56px)",
    fontWeight: 600,
    lineHeight: 1.4,
  },
  header1: {
    fontSize: "clamp(30px, 6vw, 42px)",
    fontWeight: 600,
    lineHeight: 1.4,
  },
  header: {
    fontSize: {
      base: "18px",
      md: "clamp(18px, 6vw, 20px)",
      // xl: "clamp(18px, 5vw, 20px)",
    },
    fontWeight: 600,
    lineHeight: 1.4,
  },

  xlarge: {
    fontSize: { base: "30px", md: "34px" },
    fontWeight: 600,
    lineHeight: "1.5",
  },
};
